module.exports = __webpack_public_path__ + "fonts/fa-solid-900.035a137a.eot";